import { Card } from "./ui/card";

export function StatCard({ testid, label, value, sub, icon: Icon, tone = "primary", delay = 0 }) {
  const tones = {
    primary: "text-primary bg-primary/10",
    emerald: "text-[hsl(var(--emerald))] bg-[hsl(var(--emerald)/0.12)]",
    accent: "text-accent bg-accent/12",
    terracotta: "text-[hsl(var(--terracotta))] bg-[hsl(var(--terracotta)/0.12)]",
    destructive: "text-destructive bg-destructive/10",
  };
  return (
    <Card
      data-testid={testid}
      className="animate-fade-up p-5 hover:shadow-md hover:-translate-y-0.5 transition-transform transition-shadow"
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="flex items-start justify-between">
        <p className="text-xs font-mono-nums uppercase tracking-widest text-muted-foreground">{label}</p>
        <span className={`grid h-9 w-9 place-items-center rounded-lg ${tones[tone]}`}>
          <Icon className="h-4.5 w-4.5" />
        </span>
      </div>
      <p className="mt-3 font-display text-2xl sm:text-3xl font-extrabold tracking-tight font-mono-nums">{value}</p>
      {sub && <p className="mt-1 text-xs text-muted-foreground">{sub}</p>}
    </Card>
  );
}
